import Swiper from "swiper/bundle";
import { Autoplay, Pagination, Navigation } from "swiper/modules";

export class Hero {
  constructor(el) {
    this.el = el;
    this.img = el.querySelector('.hero--media img');
    this.ticking = false;
    this.init();
  }

  init() {
    if (!this.img) return;

    window.addEventListener(
      'scroll',
      () => this.onScroll(),
      { passive: true }
    );

    this.parallax();
  }

  onScroll() {
    if (this.ticking) return;

    this.ticking = true;

    requestAnimationFrame(() => {
      this.parallax();
      this.ticking = false;
    });
  }

  parallax() {
    const rect = this.el.getBoundingClientRect();

    if (rect.bottom < 0 || rect.top > window.innerHeight) return;

    this.img.style.transform = `translateY(${rect.top * 0.3}px)`;
  }
}

export class SliderHero {
  constructor(el) {
    this.el = el
    this.swiper = null
    this.init()
  }

  init() {
    const swiperEl = this.el.querySelector('.hero--swiper')

    if (!swiperEl) return

    this.swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Pagination, Navigation],

      loop: true,
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 0,

      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      },

      pagination: {
        el: this.el.querySelector('.swiper-pagination'),
        type: 'progressbar'
      },

      navigation: {
        nextEl: this.el.querySelector('.hero--next')
      }
    })
  }
}